import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type TasApplicationModel from 'tio-common/models/tas-application';
interface Params {
  tas_application_id: string;
}

export default class AuthenticatedAdminTasApplicationsApprovalRoute extends Route {
  @service declare store: StoreService;

  // Layout configuration - declares this route needs full-width layout
  // layoutType = 'full-width' as const;

  // @ts-expect-error - Route model signature mismatch with Ember Route types
  async model(params: Params): Promise<TasApplicationModel> {
    // Fetch the application with all related data needed for approval
    // Using new data structure with tas_fields as a relationship
    const application = (await this.store.findRecord('tas-application', params.tas_application_id, {
      include: [
        'tas-program-instance.tas-program-template.tas-field-options',
        'tas-program-instance.employee',
        'tas-program-instance.employee.person',
        'tas-program-instance.employee.company',
        'tas-program-instance.employee.company.comments',
        'tas-program-instance.employee.tas-participant',
        'tas-program-instance.tas-assets',
        'tas-program-instance.tas-assets.attachments',
        'tas-program-instance.tas-assets.asset-summary',
        'tas-program-limit',
        'tas-courses.tas-assets',
        'tas-courses.tas-assets.attachments',
        'tas-courses.tas-assets.asset-summary',
        'tas-assets',
        'tas-assets.attachments',
        'tas-assets.asset-summary',
        'tas-assistances',
        'attachments',
        'ai-recommendations',
        'comments',
        'comments.person',
      ],
    })) as TasApplicationModel;

    await application.loadHistory();

    return application;
  }
}
